import styled from "styled-components";
import { SectionWrapper } from "shared/Styles/Wrappers";

export const Container = styled(SectionWrapper)`
  padding: 96px 0 64px 0;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding: 64px 0 24px 0;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 36px 0 0px 0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 64px;
  margin-top: 24px;
`;

export const TitleWrapper = styled.div`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0 24px;
  }
`;
